<template>
  <div class="robot_wrap" ref="robot_wrap" :style="{'z-index': ['9999', '1999'][+robotHide]}">
    <div ref="robot_tips" class="robot_tips" :class="{'fadeOutRight':show,'fadeInRight':!show}" @mousedown="mouseDown">
      <el-badge class="my-badge" style="width: 100%;" :value="deepingTaskCount" :hidden="!deepingTaskCount">
        <img :src="robot" alt="" srcset="">
      </el-badge>
    </div>
    <div v-show="show" class="robotContent" ref="robotContent" v-loading='waiting' :class="{'fadeInBottomRight':show,'fadeOutBottomRight':!show}">
      <div class="closeContent" @click="closeContent"><i class="el-icon-close"></i></div>
      <!-- <robot-view1 class="robot-view" :showBack="!!deepTaskList.length" ref="robotView1" v-if="true" :key="1"></robot-view1> -->
      
      <!-- <robot-view1 class="robot-view h-auto" :showBack="!!deepTaskList.length" ref="robotView1" v-if="!deepTaskList.length || activeIndex == 1" :key="1"></robot-view1> -->
      <robot-view1 class="robot-view h-auto" ref="robotView1" v-if="activeIndex == 1" :key="1"></robot-view1>
      <robot-view2 class="robot-view" style="max-height: 432px;" v-else-if="activeIndex == 2" :key="2"></robot-view2>
      <robot-view3 class="robot-view" style="max-height: 432px;" v-else-if="activeIndex == 3" :key="3"></robot-view3>
      <robot-view v-else class="robot-view" :deepingTaskCount="deepingTaskCount" :key="4"></robot-view>

      
      
      <!-- <robot-view2 class="robot-view" style="max-height: 432px;"></robot-view2> -->
      
      
    </div>
    <div v-show="show" class="zezhao" @click.stop="closeContent"></div>
  </div>
</template>

<script>
import robot from '@/assets/robot.png'

import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import robotView from '@/views/clue/components/robotView'
import robotView1 from '@/views/clue/components/robotView1'
import robotView2 from '@/views/clue/components/robotView2'
import robotView3 from '@/views/clue/components/robotView3'

export default {
  name: 'robot',
  componentName: "robot",
  components: {
    robotView,
    robotView1,
    robotView2,
    robotView3
  },
  data() {
    return {
      waiting: false,
      show: false,
      activeIndex: 0,  // 0-小T  1-推荐线索  2-深度挖掘 3-商机订阅
      robot,
      mouseLocation: { x: 0, y: 0 },
      domOffset: {},
      ww: window.innerWidth,
      wh: window.innerHeight,
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus,
      robotHide: state => state.user.robotHide,
      deepTaskList: state => state.user.deepTaskList,
    }),
    ...mapGetters(['deepingTaskCount']),
  },
  watch: {
    show(val) {
      if (!val) {
        const domW = this.$refs['robot_wrap']
        this.$nextTick(() => {
          const domT = this.$refs['robot_tips']
          if (domW.style.top) domT.style.top = domW.style.top
          if (domW.style.left) domT.style.left = domW.style.left
        })
      } else {
        this.activeIndex = 0
      }
    }
  },
  mounted() {
    window.addEventListener('mouseup', this.mouseUp)
    window.addEventListener('resize', this.windowResize)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.windowResize)
      window.removeEventListener('mouseup', this.mouseUp)
    })
    this.$on('waitingChange', this.handleWaitingChange)
    this.$on('activeIndexChange', (i) => this.activeIndex = i)
  },
  methods: {
    handleWaitingChange(val) {
      this.waiting = val
    },
    windowResize() {
      this.ww = window.innerWidth
      this.wh = window.innerHeight
    },
    showContent() {
      this.show = !this.show
    },
    closeContent() {
      this.show = false
    },
    mouseDown(e) {
      e.preventDefault()
      const dom = this.$refs['robot_tips']
      // 获取鼠标位置
      const clientX = e.clientX
      const clientY = e.clientY

      // 在元素身上位置
      const offsetX = clientX - dom.offsetLeft
      const offsetY = clientY - dom.offsetTop

      const location = { offsetX, offsetY }
      this.mouseLocation.x = clientX
      this.mouseLocation.y = clientY

      this.domOffset.x = offsetX
      this.domOffset.y = offsetY

      window.addEventListener('mousemove', this.mouseMove)

      dom.addEventListener('mouseup', this.showContent)
    },
    mouseUp(e) {
      const dom = this.$refs['robot_tips']

      window.removeEventListener('mousemove', this.mouseMove)

      dom && (dom.style.cursor = 'pointer')

      this.computeBound()
    },
    mouseMove(e) {
      const dom = this.$refs['robot_tips']
      const wrap = this.$refs['robot_wrap']

      // 鼠标位置
      let clientX = e.clientX
      let clientY = e.clientY

      // 判断位置 否则在chrome 会判定移动
      if (this.mouseLocation.x !== clientX || this.mouseLocation.y !== clientY) {
        // 取消点击事件
        dom.removeEventListener('mouseup', this.showContent)
        dom && (dom.style.cursor = 'move')
      }
      dom && (dom.style.cursor = 'move')

      // 设置拖动物体
      dom.style.left = (clientX - this.domOffset.x) + 'px'
      dom.style.top = (clientY - this.domOffset.y) + 'px'
      wrap.style.left = (clientX - this.domOffset.x) + 'px'
      wrap.style.top = (clientY - this.domOffset.y) + 'px'
    },
    // 边界处理
    computeBound() {
      this.$nextTick(() => {
        const domC = this.$refs['robotContent']
        const domT = this.$refs['robot_tips']
        const domW = this.$refs['robot_wrap']
        // right
        if (domW && (domW.offsetLeft + domW.offsetWidth) > this.ww) {
          domT.style.left = (this.ww - domT.offsetWidth - 10) + 'px'
          domW.style.left = (this.ww - domW.offsetWidth - 10) + 'px'
        }

        if (domC && (domC.offsetLeft + domC.parentNode.offsetLeft + domC.offsetWidth) > this.ww) {
          domC.style.left = (this.ww - domC.parentNode.offsetLeft - domC.offsetWidth - 10) + 'px'
        }

        // left
        if (domW && (domW.offsetLeft) < 80) {
          domT.style.left = 80 + 'px'
          domW.style.left = 80 + 'px'
        }

        if (domC && (domC.offsetLeft + domC.parentNode.offsetLeft) < 80) {
          domC.style.left = 0 + 'px'
        }

        // top
        if (domW && (domW.offsetTop) < 180) {
          domT.style.top = 180 + 'px'
          domW.style.top = 180 + 'px'
        }

        // bottom
        if (domW && domT.offsetTop + domW.offsetHeight > this.wh) {
          domT.style.top = this.wh - domT.offsetHeight + 'px'
          domW.style.top = this.wh - domT.offsetHeight + 'px'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.robot-view {
  max-height: 320px;
}
.h-auto{
  max-height: 1000px !important;
}

.my-badge /deep/ .el-badge__content.is-fixed {
  top: 20px;
  right: 20px;
}
.robot_wrap {
  position: fixed;
  z-index: 9999;
  top: 50%;
  right: 0px;
  width: 50px;
  height: 50px;
  .robot_tips {
    width: 50px;
    position: fixed;
    top: 50%;
    right: 0px;
    cursor: pointer;
    .el-badge > img {
      width: 100%;
    }
  }
  .robotContent {
    color: rgba(51, 51, 51, 1);
    border-radius: 7px;
    padding: 14px 24px;
    width: 384px;
    
    // max-height: 240px;
    position: relative;
    top: -150px;
    left: -120px;
    background-color: #ffffff;
    text-align: left;
    padding-bottom: 40px;

    .closeContent {
      position: absolute;
      top: 10px;
      right: 10px;
      
      cursor: pointer;
    }
  }

  // .moeIcon,
  // .moeModal {
  //   position: fixed;
  //   bottom: 60px;
  //   z-index: 1000;
  //   color: #fff;
  // }
  // .moeIcon {
  //   line-height: 1;
  //   right: 18px;
  //   background-color: rgba(0, 0, 0, 0.8);
  //   width: 60px;
  //   padding: 15px;
  //   border-radius: 50%;
  //   box-shadow: 0 5px 20px 0 rgba(50, 57, 81, 0.5);
  // }
  // .moeIcon > img {
  //   width: 30px;
  //   height: 30px;
  // }
  // .moeModal {
  //   right: 12px;
  //   padding: 12px 16px 30px;
  //   min-width: 263px;
  //   border-radius: 8px;
  //   display: none;
  //   background: #161a26;
  // }

  .fadeInRight {
    animation-name: fadeInRight;
  }
  .fadeInBottomRight,
  .fadeInRight,
  .fadeOutBottomRight,
  .fadeOutRight {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-name: fadeOutRight;
  }
  .fadeInBottomRight,
  .fadeOutBottomRight {
    display: block;
  }
  .fadeInBottomRight,
  .fadeInRight {
    animation-delay: 0.3s;
  }
  @keyframes fadeOutRight {
    0% {
      opacity: 1;
      transform: translateX(0);
    }
    to {
      opacity: 0;
      transform: translateX(50px);
    }
  }
  @keyframes fadeInBottomRight {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    to {
      opacity: 1;
      transform: scale(100%);
    }
  }
  .fadeInBottomRight {
    animation-name: fadeInBottomRight;
  }
  @keyframes fadeInRight {
    0% {
      opacity: 0;
      transform: translate(100%);
    }
    to {
      opacity: 1;
      transform: translate(0);
    }
  }

  .fadeInRight {
    animation-name: fadeInRight;
  }
  .fadeInBottomRight,
  .fadeInRight,
  .fadeOutBottomRight,
  .fadeOutRight {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    transform-origin: 100% 100% 0;
  }
  .fadeInBottomRight,
  .fadeOutBottomRight {
    display: block;
  }
  .fadeInBottomRight,
  .fadeInRight {
    animation-delay: 0.3s;
  }
}
.zezhao{
  position:fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3000);
  z-index: -1;
}
</style>
